import { createSlice, current } from '@reduxjs/toolkit';




const initialState = {
  users:[]
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, { payload }) => {
     
      state.users = [...payload];
    },
    
   
    clearUsersState: (state) => {
      state=initialState
    }
  }
});

export const { setUsers, clearUsersState } = usersSlice.actions;

export const usersData = (state) => state.users;


export default usersSlice.reducer;
